import { render, staticRenderFns } from "./productseries.vue?vue&type=template&id=3f17bf8a&scoped=true&"
import script from "./productseries.vue?vue&type=script&lang=js&"
export * from "./productseries.vue?vue&type=script&lang=js&"
import style0 from "./productseries.vue?vue&type=style&index=0&id=3f17bf8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f17bf8a",
  null
  
)

export default component.exports